import {
  Box,
  Button,
  ButtonProps,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Stack,
} from '@chakra-ui/react';
import { Link as ChakraLink } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React, { FC } from 'react';

interface ContactPopoverButtonProps {
  street?: string;
  company?: string;
  postcode?: string;
  city?: string;
  email?: string;
  homepage?: string;
  phone?: string;
  fax?: string;
  buttonProps?: ButtonProps;
  popoverColor?: string;
  id?: number;
}

const ContactPopoverButton: FC<ContactPopoverButtonProps> = ({
  street,
  company,
  postcode,
  city,
  email,
  homepage,
  phone,
  fax,
  id,
  buttonProps,
  popoverColor,
}) => {
  const router = useRouter();

  return (
    <Popover
      onOpen={() => {
        if ((window as any).gtag) {
          (window as any).gtag('event', 'contact_popover', {
            page_path: router.asPath,
            hotelId: id,
          });
        }
      }}
    >
      <PopoverTrigger>
        <Button width="100%" type="submit" colorScheme="blue" {...buttonProps}>
          Kontaktinformationen
        </Button>
      </PopoverTrigger>
      <PopoverContent color={popoverColor || 'inherit'}>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>Kontaktinformationen</PopoverHeader>
        <PopoverBody>
          <Stack spacing={0}>
            <Box marginBottom={4}>
              {company && <Box fontWeight="bold">{company}</Box>}
              {street && <Box>{street}</Box>}
              {(postcode || city) && (
                <Box>
                  {postcode} {city}
                </Box>
              )}
            </Box>
            {homepage && (
              <Box>
                Homepage:{' '}
                <ChakraLink isExternal href={homepage} target="_blank">
                  {homepage}
                </ChakraLink>
              </Box>
            )}
            {phone && (
              <Box>
                Tel.:{' '}
                <ChakraLink href={`tel:${phone}`} target="_blank">
                  {phone}
                </ChakraLink>
              </Box>
            )}
            {fax && <Box>Fax: {fax}</Box>}
          </Stack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ContactPopoverButton;
